import React from 'react';
import cx from 'classnames';
import styles from '../CallNow.module.css';

interface Props {
  children: React.ReactNode;
  hasToCall: boolean;
  seeNumber: boolean;
  onClick: () => void;
  type: 'big' | 'small';
  dataValue?: string;
  dataValueClassName?: string;
}
export const ContainerCallNow = ({
  children,
  hasToCall,
  seeNumber,
  onClick,
  type,
  dataValue,
  dataValueClassName,
}: Props) => {
  const commonStyle = 'w-100 br10 flex transition-ease items-start pointer bn';
  const styleByType = type === 'small' ? styles.callNowContainer : 'pv24 ph12';

  const wrapperPhone = cx(
    commonStyle,
    dataValueClassName,
    {
      [styles.bgWhatsApp]: !hasToCall,
      [styles.bgPhoneNumber]: hasToCall,
      [styles.initialHeightContainer]: !seeNumber,
      [styles.finallyHeightContainter]: seeNumber,
    },
    styleByType,
  );
  const handleKeyPress = (e: any) => {
    const keyCode = e.which || e.keyCode;
    const ENTER = 13;
    if (keyCode === ENTER && onClick && !seeNumber) {
      onClick();
    }
  };

  return (
    <div
      tabIndex={0}
      className={wrapperPhone}
      onClick={!seeNumber ? onClick : () => null}
      onKeyPress={handleKeyPress}
      data-value={dataValue}
    >
      {children}
    </div>
  );
};
